<div>
  <form class="cp-lf__container" on-submit('onSubmit')>
    <div>
      <ebay-textbox
        placeholder="username"
        fluid=true
        on-change('onChange', 'username')
      >
        <@prefix-icon>
          <ebay-profile-24-icon/>
        </@prefix-icon>
      </ebay-textbox>
    </div>
    <div>
      <ebay-textbox
        placeholder="password"
        fluid=true
        type="password"
        on-change('onChange', 'password')
      >
        <@prefix-icon>
          <ebay-key-24-icon/>
        </@prefix-icon>
      </ebay-textbox>
    </div>
    <div>
      <ebay-button
        fluid=true
        borderless=false
        variant="form"
        type="submit"
      >
        Login
      </ebay-button>
    </div>
  </form>
  <div class="cp-lf__message">${state.message}</div>
</div>

style {
  .cp-lf__container {
    width: 20rem;
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }

  .cp-lf__message {
    text-align: center;
    margin: 1rem 0;
    min-height: 1.1rem;
  }
}
